// eslint-disable-next-line no-restricted-imports
import { Link as GatsbyLink } from 'gatsby';
import React, { ReactNode } from 'react';

interface LinkProps {
  to: string,
  className?: string
  children?: ReactNode
}

/**
 * Adds a trailing slash to all URLs. Always use this component instead of GatsbyLink.
 * @param {string} to - The URL to navigate to.
 * @returns A Gatsby Link component with a modified URL.
 */
const Link = ({ to, ...props }: LinkProps) => {
  // If the URL is a file, or it's external, don't do anything
  if (to.includes('.') || to.startsWith("#")) return <GatsbyLink to={to} {...props} />;

  let origin;
  if (typeof window === 'undefined') {
    origin = 'https://www.themobileshop.ca';
  } else {
    origin = window.location.origin;
  }
  
  const urlObject = new URL(to, origin);
  let { pathname } = urlObject;
  if (!pathname.endsWith('/')) pathname += '/';

  // Combine pathname with search and hash
  let url = `${pathname}${urlObject.search}${urlObject.hash}`;

  // Ensure a trailing slash is added after query parameters or hash if needed
  if ((urlObject.search || urlObject.hash) && !url.endsWith('/')) url += '/';

  // Return wrapped gatsby link with new URL
  return <GatsbyLink to={url} {...props} />;
};

export default Link;
